define('glu/grid/savedViews/components/dropdownItemView',['require','../../../flexDropdown/views/flexDropdownItemView','hbs!./dropdownItemView.hbs','../../../util','../../../dialog','../../../locale'],function(require) {
    'use strict';

    var FlexDropdownItemView = require('../../../flexDropdown/views/flexDropdownItemView'),
        tmpl = require('hbs!./dropdownItemView.hbs'),
        util = require('../../../util'),
        dialog = require('../../../dialog'),
        locale = require('../../../locale');

    return FlexDropdownItemView.extend({
        template: tmpl,

        collectionEvents: {
            'change:default': 'render'
        },

        initialize: function(options) {
            this.collection = (options || {}).savedViewsCollection;
        },

        getModel: function() {
            // this is necessary since flexDropdown works with a separate collection
            return this.collection.findWhere({
                id: this.model.get('id')
            });
        },

        events: function() {
            var events = FlexDropdownItemView.prototype.events.apply(this, arguments);

            return util.extend(events, {
                'click .grid-saved-views-remove': 'handleSavedViewRemove',
                'click .grid-save-view-make-default': 'makeSavedViewDefault'
            });
        },

        className: function() {
            var className = FlexDropdownItemView.prototype.className.apply(this, arguments);

            className += ' row';

            if (this.model.get('notVisibleItem')) {
                className += ' hidden';
            }

            return className;
        },

        templateHelpers: function() {
            var helpers = FlexDropdownItemView.prototype.templateHelpers.apply(this, arguments),
                model = this.getModel();

            return util.extend(helpers, {
                isDefault: model && model.get('default')
            });
        },

        handleSavedViewRemove: function(e) {
            e.preventDefault();
            e.stopPropagation();

            this.showDialog('removeSavedView', 'removeSavedViewMsg', this.removeSavedView);
        },

        makeSavedViewDefault: function(e) {
            e.preventDefault();

            this.makeDefaultSavedView();
        },

        showDialog: function(title, message, handler) {
            handler = handler || function() {};

            dialog.confirm(locale.get(message, this.model.get('name')), locale.get(title), function(ok) {
                if (ok) {
                    handler.call(this);
                }
            }.bind(this));
        },

        removeSavedView: function() {
            var model = this.getModel();
            if (model) {
                // remove from flex dropdown collection
                this.model.collection.remove(this.model);
                // remove from views collection
                this.collection.remove(model);
            }
        },

        makeDefaultSavedView: function() {
            var model = this.getModel();
            if (model) {
                model.set({
                    'default': true
                });
            }
        }
    });
});

